export default {
    data: () => ({
        cep: '',
        shipping_id: 0,
        carrier_id: 0,
        order: {},
        shippings: {}
    }),
    computed: {
        products() {
            if ('produtos' in this.$store.state.order.order) {
                return this.$store.state.order.order.produtos
            }
            return {}
        },
        discount_coupon() {
            if ('valor_cupom_desconto' in this.$store.state.order.order) {
                return parseFloat(this.$store.state.order.order.valor_cupom_desconto * (-1))
            }
            return 0
        },
        subtotal() {
            if ('valor_subtotal' in this.$store.state.order.order) {
                return parseFloat(this.$store.state.order.order.valor_subtotal)
            }
            return 0
        },
        freight() {
            if ('valor_frete' in this.$store.state.order.order) {
                return parseFloat(this.$store.state.order.order.valor_frete)
            }
            return 0
        },
        total() {
            if ('valor_total' in this.$store.state.order.order) {
                return parseFloat(this.$store.state.order.order.valor_total)
            }
            return 0
        },
        total_items() {
            if ('quantidade_total' in this.$store.state.order.order) {
                return this.$store.state.order.order.quantidade_total
            }
            return 0
        },
        minimum_order_value() {
            if ('minimum_order_value' in this.$store.state.order.order) {
                return parseFloat(this.$store.state.order.order.minimum_order_value)
            }
            return 0
        },
        showCouponSuccessInProduct() {
            try {
                return parseInt(this.$store.state.order.order.discount_coupon.id_aplicacao) > 1
            } catch (e) {
                return false
            }
        }
    },
    methods: {
        saveQtyProduct(product, qty) {
            this.$axios.$put(`/?p=ecommerce_pedidos_produtos_api_v1&code=${product.codigo}`, {qty: qty})
                .then((response) => {
                    if (response.status === 'success') {
                        this.$fetch();
                    } else {
                        throw response.message;
                    }
                })
                .catch(error => {
                    console.error(error);
                    if (typeof bootbox === 'object') {
                        bootbox.dialog({
                            message: `<div class="py-3 text-center">${error}</div>`,
                            backdrop: true,
                            onEscape: function () {
                            },
                        });
                    } else {
                        alert(error);
                    }
                    this.$fetch();
                })
        },
        removeProductCart(product) {
            if (!confirm('Você tem certeza que quer remover esse item?')) {
                return;
            }
            this.$axios.$delete(`/?p=ecommerce_pedidos_produtos_api_v1&code=${product.codigo}`)
                .then((response) => {
                    if (response.status === 'success') {
                        this.$fetch();
                    } else {
                        throw 'Não foi possível remover o produto';
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    if (typeof bootbox === 'object') {
                        bootbox.dialog({
                            message: `<div class="py-3 text-center">${error}</div>`,
                            backdrop: true,
                            onEscape: function () {
                            },
                        });
                    } else {
                        alert(error);
                    }
                })
        },
        changeShipping() {
            const params = new URLSearchParams();
            params.append('cep', this.cep);
            params.append('id_frete', this.shipping_id);
            params.append('id_frete_transportadora', this.carrier_id);
            this.$axios.$post(`/?p=ecommerce_pedidos_api_v1&metodo=frete`, params)
                .then((response) => {
                    if (response.msg !== 'sucesso') {
                        throw 'Não foi possível atualizar a forma de frete';
                    }
                    this.$store.commit('order/setNewShippingPrice', response)
                    this.$store.dispatch('order/loadOrder')
                })
                .catch((error) => {
                    console.error(error);
                })
        },
        isValidInCoupon(product_code) {
            if (this.$store.state.order.order.cupom_desconto) {
                try {
                    return this.$store.state.order.order.discount_coupon.produtos_validos.find(el => {
                        return el === product_code
                    })
                } catch (e) {
                    console.error(e)
                }
            }
            return true
        },
        isValidFreightInCoupon(product_code) {
            if (this.$store.state.order.order.cupom_desconto) {
                if (this.$store.state.order.order.discount_coupon.frete_valido === 'sim') {
                    return true
                }
                try {
                    return this.$store.state.order.order.discount_coupon.produtos_validos.find(el => {
                        return el === product_code
                    })
                } catch (e) {
                    console.error(e)
                }
            }
            return true
        },
    },
    watch: {
        shipping_id(newvalue) {
            let shipping = this.shippings.filter((item) => {
                return item.id == newvalue;
            })
            if (shipping && shipping != 2) {
                this.changeShipping();
            }
        },
        carrier_id(newvalue) {
            if (newvalue) {
                this.changeShipping();
            }
        },
        order: {
            handler: function (newvalue) {
                this.$root.$emit('change_cart', JSON.stringify(newvalue))
            },
            deep: true
        }
    },
    async fetch() {
        this.shippings = await this.$axios.$get(`api/v1/ecommerce/shipments/orders/${this.cep}`).then((res) => {
            return res.data
        });
    },
    mounted() {
        // this.shipping_id = this.$store.state.order.order.frete.id
    }
}
